interface Formation {
  image: string;
  title: string;
  description: string;
  id?: string;
  content?: React.ReactElement;
  type: TypeFormation;
}

enum TypeFormation {
  FormationCatalogue,
  FormationSpecifique,
  FormationTendance,
  BilanDeCompetence,
  Coaching
}

export { TypeFormation };
export default Formation;
